import React from "react";
import { observer } from "mobx-react";
import { linkedInTemplatePopupState } from "./LinkedInTemplatePopupState";
import { ReactComponent as LinkedinIcon } from "Assets/svg/linkedin.svg";
import { ReactComponent as CloseIcon } from "Assets/svg/close-material.svg";
import Button from "Components/common/Button";
import Utils from "Utils/utils";
import ConstantObj from "Static/constant";
import { withRouter } from "react-router-dom";

const LinkedInTemplateDetailsPopup = observer((props) => {
  const {
    showDetailsPopup,
    setShowDetailsPopup,
    setShowTemplatesListPopup,
    detailsTemplateData,
    applyLinkedInTemplate,
    applyTemplateLoader
  } = linkedInTemplatePopupState;

  if (!showDetailsPopup || !detailsTemplateData) return null;

  const handleClose = () => {
    if (applyTemplateLoader) return;
    setShowDetailsPopup(false);
  };

  const handleBack = () => {
    if (applyTemplateLoader) return;
    setShowDetailsPopup(false);
    setShowTemplatesListPopup(true);
  };

  const handleUseTemplate = () => {
    if (detailsTemplateData && !applyTemplateLoader) {
      const folderId = Utils.getFolderDetails()?.folderId;
      applyLinkedInTemplate(detailsTemplateData.id, folderId, props.history);
    }
  };

  const renderSteps = () => {
    const { steps = {} } = detailsTemplateData;
    // steps is an object where keys are string integers ("1", "2", ...)
    const stepsArray = Object.entries(steps).sort((a, b) => parseInt(a[0]) - parseInt(b[0]));

    return stepsArray.map(([stepNo, stepData], index) => {
      // stepData contains a "variants" object
      const variant = stepData.variants ? Object.values(stepData.variants)[0] : {};
      
      const type = variant?.linkedInTaskType || "";
      const content = variant?.text || "";
      const daysLater = stepData?.daysLater || 0;
      
      // Lookup title using lowercase version of task type (e.g., "li_view_profile")
      const stepTitle = ConstantObj.taskSubject[type.toLowerCase()] || type;

      return (
        <div className="stepCard" key={index}>
          <div className="stepHeader">
            <div className="titleGroup">
              <LinkedinIcon className="liIcon" />
              <span className="stepTitle">Step {stepNo} - {stepTitle}</span>
            </div>
            <span className="dayCount">Day {daysLater}</span>
          </div>
          <div className="stepContent">
            {content && <p className="previewText">{content}</p>}
          </div>
        </div>
      );
    });
  };

  return (
    <div className="linkedinTemplateDetailsPopupSection">
      <div className="card animated customzoomIn">
        <div className="popupHeader">
          <div className="headerInfo">
            <h2 className="title">{detailsTemplateData.name}</h2>
            {detailsTemplateData.description && (
              <p className="bestFor">
                <strong>Best for:</strong> {detailsTemplateData.description}
              </p>
            )}
            {detailsTemplateData.goal && (
              <p className="goalText">
                <strong>Goal:</strong> {detailsTemplateData.goal}
              </p>
            )}
          </div>
          <CloseIcon
            className={`closeIcon ${applyTemplateLoader ? "disabled" : ""}`}
            onClick={handleClose}
          />
        </div>
        <div className="stepsWrapper">
          {renderSteps()}
        </div>
        <div className="popupFooter">
          <button
            className="backBtn"
            onClick={handleBack}
            disabled={applyTemplateLoader}
          >
            Back
          </button>
          <Button
            btnText={linkedInTemplatePopupState.targetSequenceId ? "Use Template" : "Create and Customize"}
            className={`useTemplateBtn ${applyTemplateLoader ? "loading" : ""}`}
            knobs={applyTemplateLoader}
            click={handleUseTemplate}
          />
        </div>
      </div>
      <div className="overlayMaskPopup" onClick={handleClose}></div>
    </div>
  );
});

export default withRouter(LinkedInTemplateDetailsPopup);
